const KEYS = [
  'id',
  'userBestCash',
  'userAvgCash',
  'peersBestCash',
  'peersAvgCash',
  'userPatientPerHour',
  'peersPatientPerHour',
  'userAvgCashPerPatient',
  'peersAvgCashPerPatient',
  'userAvgPatientsPerShift',
  'peersAvgPatientsPerShift',
  'userBilledSoFar',
  'userPatientsSeen',
  'userAvgShiftLength',
  'peersAvgShiftLength',
  'lastUpdated',
  'userAvgCashRank',
  'userNewPatientsRank',
  'userAvgCashPerPatientRank',
  'userAvgPatientsPerShiftRank',
] as const;

export type DashboardData = { [K in (typeof KEYS)[number]]: string | null };

export function dashboardFromJson(json: Record<string, unknown>): DashboardData {
  return Object.fromEntries(
    KEYS.map((k) => [k, json[k] == null ? null : String(json[k])]),
  ) as DashboardData;
}
